<template>
  <div id="footer">
    <p
      id="legal"
      class="font-weight-medium blue-grey--text text--darken-4 subheading"
    >
      RETHYMOS Limited &copy; {{ new Date().getFullYear() }}
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Crimson+Text");

#footer {
  text-align: center;
  background-color: #d3d3d3;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

#legal {
  margin-bottom: 0px;

  color: black;
  text-decoration: none;
}
</style>